import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'; // You can create this CSS file for additional styling
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
